import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import KinerjaNotifikasiIndex from 'app/KinerjaNotifikasiPage/pages/Index'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isNotifikasiEnabled =
      process.env.NEXT_PUBLIC_SKP_NOTIFIKASI_ENABLED === 'true'

    if (!toggle?.['kinerja-enabled'] || !isNotifikasiEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => <KinerjaNotifikasiIndex />

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}

export default Page
